import { Info } from "@mui/icons-material";
import { IconButton, Stack, Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import MyDialog from "../../../../components/MyDialog";
import MyTable from "../../../../components/MyTable";
import { AuthStore } from "../../../../store/UserStore";
import { base_url } from "../../../../utils/GlobalVariables";
import { CustomDescrypt } from "../../../../utils/MyEncryption";


const Data = () => {
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [dialogData, setDialogData] = useState({});
    const [openDialog, setOpenDialog] = useState(false);

    const columns = [
        {
            field: 'action',
            headerName: '...',
            sortable: false,
            filterable: false,
            hideable: false,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {

                const handleOpenDialog = () => {
                    // console.log(data);
                    setDialogData(params.row)
                    setOpenDialog(true);
                };

                return (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Detail">
                            <IconButton aria-label="edit" color="info" onClick={handleOpenDialog}>
                                <Info />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                );
            }
        },
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 200,
            // type: "boolean"
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        }
    ];

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const requestData = () => {
        console.log('req data');
        setTableLoading(true)
        axios.get(
            base_url + '/admin/pencairan/ttd_sp2d',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
            })
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <>
            <MyTable
                rows={tableData}
                columns={columns}
                row_id={(row) => row.no_spm}
                isLoading={tableLoading}
            />
            <MyDialog dialogData={dialogData} openDialog={openDialog} handleCloseDialog={handleCloseDialog} decryptedUser={decryptedUser} />
        </>
    )
}

export { Data as DataTtdSp2d }